import React, {Component} from 'react';
import IPost from '../../core/models/post';
import moment from 'moment';
import '../../styles/carousel-post.scss';
const prodprefix = 'https://pancan.org';

class PostCarousel extends Component < IPost > {
     constructor(props : IPost) {
          super(props);
          this.createMarkup = this
               .createMarkup
               .bind(this);
     }

     public createMarkup(data : any) : any {
          return {__html: data};
     }

     public render() {     

               
          return (
               <div className="post-item carousel-item">
                    
                    {this.props.data.postMetaFields.images.full?
                    <a href={this.props.data.link}><img
                    className="img-responsive text-center item-image"
                    src={`${prodprefix}${this.props.data.postMetaFields.images.full}`}
                    alt={this.props.data.title.rendered}/></a>:null}
                    <div className="post-text">
                         <a href={this.props.data.link}>
                              <strong
                                   className="over-solid"
                                   dangerouslySetInnerHTML={this.createMarkup(this.props.data.title.rendered)}/>
                         </a>
                         <p className="over-solid text-date hidden">{moment(this.props.data.date).format('ll')}</p>
                         <p
                              className="over-solid hidden"
                              dangerouslySetInnerHTML={this.createMarkup(this.props.data.excerpt.rendered)}/>
                    </div>
               </div>
          );
     }
}

export default PostCarousel;